<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            Visualizar Organograma
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  :value="content.nome"
                  label="Nome da Gerência"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  :value="content.sigla"
                  label="Sigla da Gerência"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  :value="content.secretariaExecutiva.nome"
                  label="Secretaria Executiva"
                  outlined
                  dense
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="content.setores"
                  label="Setor(es)"
                  :items="form.lists.setores"
                  :item-text="'nome'"
                  :item-value="'id'"
                  outlined
                  multiple
                  readonly
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <div class="btn-group text-center mt-7">
          <v-btn color="primary" @click="$emit('onClose')"> Fechar </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from "~/commons/classes/dialog-props";
import { Organograma } from "~/commons/classes/organograma";
import OrigemEnum from "~/commons/enums/origem.enum";
import ManterOrganogramaService from "@/services/manter-organograma.service";
import ManterSetorService from "~/services/manter-setor.service";

export default {
  props: new DialogProps(Organograma),
  mixins: [ManterOrganogramaService, ManterSetorService],
  data: () => ({
    form: {
      lists: {
        setores: [],
      },
    },
  }),
  methods: {
    buscarSetores() {
      this.$buscarSetores({ params: { origem: OrigemEnum.SEE } }).then(({ data }) => this.form.lists.setores = data.itens);
    },
  },
  mounted() {
    this.buscarSetores();
  },
};
</script>
